export default {
  OWNER: 'owner',
  ADMIN: 'admin',
  MANAGER: 'manager',
  FINANCE: 'finance',
  PAYEE: 'payee',
  SUPER_ADMIN: 'super_admin',
  SUPER_ADMIN_VIEWER: 'super_admin_viewer',
  INDIVIDUAL: 'individual',
  CUSTOM: 'custom',
  AUTHORIZER: 'authorizer',
  ACCOUNT_AUTHORIZER: 'account_authorizer',
  MERCHANT_AUTHORIZER: 'merchant_authorizer',
  TRUSTEE: 'trustee',
  PAYEE_AUTHORIZER: 'payee_authorizer'
};
